module.exports = __webpack_public_path__ + "static/m_solution2-c6fa759db967b219419a376a8bb3bfda.png";